import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { User } from '../models/user.model';
import { SingUpService } from "src/app/shared/services/signup.service";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from '@ngx-translate/core';

@Injectable()

export class AuthService {

    private userSubject: BehaviorSubject<User>;
    public tokenKey:any;
    public userId:any;
    public user: Observable<User>;
    public 
    private enableParticlesSubject = new BehaviorSubject<boolean>(false);
    enableParticles$ = this.enableParticlesSubject.asObservable();
    
    url: any = environment.API_URL;

    constructor(
        private http: HttpClient,
        private signUpService: SingUpService,
        private toster:ToastrService,
        private translate: TranslateService    ) { }

    login(user: User) {
        return this.http.post<any>(this.url + 'user/login', user);
    }

    reset(email: any) {
        return this.http.patch<any>(this.url + 'user/reset-password', email);
    }


    changePassword(data: any) {
        return this.http.patch(this.url + 'user/change-password', data);
    }

    showParticles() {
        const particlesContainer = document.getElementById('particles-js');
    if (particlesContainer) {
      particlesContainer.style.display = 'block';
    }
        //this.enableParticlesSubject.next(true);
    }
    
    hideParticles() {
       // this.enableParticlesSubject.next(false);
       const particlesContainer = document.getElementById('particles-js');
    if (particlesContainer) {
      particlesContainer.style.display = 'none';
    }
    }

     // Save token to local storage
  saveToken(token: string): void {
    localStorage.setItem('token', token);
    localStorage.setItem('refresh', Date.now().toString());
  }

  // Get token from local storage
  getToken(): string | null {
    return localStorage.getItem('token');
  }

  // Remove token from local storage
  removeToken(): void {
    localStorage.removeItem('token');
  }

  // Check if token exists
  isLoggedIn(): boolean {
    return this.getToken() !== null;
  }
  
  clearLocalStorage() {
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('lang');
    localStorage.removeItem('sortTypeKey');
    localStorage.removeItem('sortTypeOrder');
    localStorage.removeItem('isViewTypeList');
}


logout() {
  let data: any = this.currentUserValue;
  let data2 = {
    userId: data ? data?._id : this.userId,
    token: this.getToken()
  }
  const params = new HttpParams()
    .set('userId', data2.userId)
    .set('token', data2.token);

  const headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded' // Set content type
  });
  if (data2.userId) {
    this.signUpService.logOut(data2).subscribe((res: any) => {
      if (res.status) {
        this.removeToken();
        this.toster.success(res.message);
      }

    });
  } else {
    this.toster.success(this.translate.instant('tooltips.messag3'), this.translate.instant('tooltips.logout'));
    this.removeToken();
  }
  this.clearLocalStorage();

}

public get currentUserValue() {
  let data = localStorage.getItem('currentUser');
  let obj: Object = {};
  if (data !== 'undefined')
      return JSON.parse(localStorage.getItem('currentUser'));
  return false;
}

}